import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import withoutAuth from 'lib/auth/without-auth'
import ForgotPassword from 'services/Auth/screens/ForgotPassword'

export default withoutAuth(
  ForgotPassword,
  `${WEB_DESKTOP_RALALI_URL}`,
  null,
  'Reset Password',
)
